import axios from "@/libs/api.request";
import axiosOri from "axios";
import config from "@/config";

function getPostRequest(data, url) {
    return axios.request({
        url: url,
        data: data,
        method: "post",
    });
}

const user = {
    userLogin(data) {
        return getPostRequest(data, "api/user/userLogin");
    },
    userLoginByPhone(data) {
        return getPostRequest(data, "api/user/userLoginByPhone");
    },
    webRegisterMemberUser(data) {
        return getPostRequest(data, "web/account/externalCustomerUserRegister");
    },
    checkUserStatus(data) {
        return getPostRequest(data, "web/account/checkUserStatus");
    },
    webSaveMemberUserInfo(data) {
        return getPostRequest(
            data,
            "web/systemManagement/memberManagement/memberInfo/webSaveMemberUserInfo",
        );
    },
    webGetMemberUserDetail(data) {
        return getPostRequest(
            data,
            "web/systemManagement/memberManagement/memberInfo/webGetMemberUserDetail",
        );
    },
    webExternalCustomerUserRegisterByPhone(data) {
        return getPostRequest(
            data,
            "web/account/webExternalCustomerUserRegisterByPhone",
        );
    },
    webResetMemberPassword(data) {
        return getPostRequest(
            data,
            "web/systemManagement/memberManagement/memberInfo/webResetMemberPassword",
        );
    },
    webGetCustomerManagerUserList(data) {
        return getPostRequest(data, "web/account/getCustomerManagerUserList");
    },
    webGetCateManagerRelationList(data) {
        return getPostRequest(data, "web/account/getCateManagerRelationList");
    },
    webGetCateManagerDetailRelationList(data) {
        return getPostRequest(data, "web/account/GetManagerDetailList");
    },
    webGetAllRegion(data) {
        return getPostRequest(
            data,
            "web/systemManagement/regionManagement/webGetAllRegion",
        );
    },
    webGetAreaList(data) {
        return getPostRequest(
            data,
            "web/systemManagement/areaManagement/webGetAreaList",
        );
    },
    webGetMemberDeliveryAddressList(data) {
        return getPostRequest(
            data,
            "web/systemManagement/memberManagement/deliveryAddress/webGetMemberDeliveryAddressList",
        );
    },
    webSaveMemberDeliveryAddress(data) {
        return getPostRequest(
            data,
            "web/systemManagement/memberManagement/deliveryAddress/webSaveMemberDeliveryAddress",
        );
    },
    webCopyDefaultMemberDeliveryAddress(data) {
        return getPostRequest(
            data,
            "web/systemManagement/memberManagement/deliveryAddress/webCopyDefaultMemberDeliveryAddress",
        );
    },
    webDeleteMemberDeliveryAddress(data) {
        return getPostRequest(
            data,
            "web/systemManagement/memberManagement/deliveryAddress/webDeleteMemberDeliveryAddress",
        );
    },
    webGetMyMember(data) {
        return getPostRequest(data, "web/account/webGetMyMemberList");
    },
    webGetAllDistributionStationList(data) {
        return getPostRequest(
            data,
            "web/systemManagement/distributionStationManagement/webGetAllDistributionStationList",
        );
    },
    webGetMyFundRecord(data) {
        return getPostRequest(
            data,
            "web/financeManagement/memberFund/webGetMyFundRecord",
        );
    },
    webGetMyInvoiceRecord(data) {
        return getPostRequest(
            data,
            "web/financeManagement/invoice/webGetMyInvoiceRecord",
        );
    },
    webGetInvoice(data) {
        return getPostRequest(
            data,
            "web/financeManagement/invoice/webGetInvoice",
        );
    },
    webApplyInvoice(data) {
        return getPostRequest(
            data,
            "web/financeManagement/invoice/webApplyInvoice",
        );
    },
    webSubmitInvoice(data) {
        return getPostRequest(
            data,
            "web/financeManagement/invoice/webSubmitInvoice",
        );
    },
    webSaveInvoiceAccount(data) {
        return getPostRequest(
            data,
            "web/financeManagement/invoice/webSaveInvoiceAccount",
        );
    },
    webGetInvoiceAccount(data) {
        return getPostRequest(
            data,
            "web/financeManagement/invoice/webGetInvoiceAccount",
        );
    },
    getInvoiceInfo(data) {
        return getPostRequest(
            data,
            "api/financeManagement/invoice/getInvoiceInfo",
        );
    },
    accounterWithdrawInvoice(data) {
        return getPostRequest(
            data,
            "api/financeManagement/invoice/accounterWithdrawInvoice",
        );
    },
    webCreateBankRecord(data) {
        return getPostRequest(
            data,
            "web/financeManagement/bankRecord/webCreateBankRecord",
        );
    },
    webGetSuggestionList(data) {
        return getPostRequest(
            data,
            "api/systemManagement/suggestionManagement/web/webGetSuggestionList",
        );
    },
    webSaveSuggestion(data) {
        return getPostRequest(
            data,
            "api/systemManagement/suggestionManagement/web/webSaveSuggestion",
        );
    },
    webWithdrawSuggestion(data) {
        return getPostRequest(
            data,
            "api/systemManagement/suggestionManagement/web/webWithdrawSuggestion",
        );
    },
    externalCustomerGetSmsCode(data) {
        return getPostRequest(data, "web/account/externalCustomerGetSmsCode");
    },
    externalCustomerUserRegisterByPhone(data) {
        return getPostRequest(
            data,
            "web/account/externalCustomerUserRegisterByPhone",
        );
    },
    // 生产种类
    webGetMainCategoryList(data) {
        return getPostRequest(data, "web/category/getMainCategoryList");
    },
    //fdd
    registerFddAccount(data) {
        return getPostRequest(data, "api/esignature/registerFddAccount");
    },
    SignContract(data) {
        return getPostRequest(data, "api/esignature/SignContract");
    },
    AutoSignContract(data) {
        return getPostRequest(data, "api/esignature/AutoSignContract");
    },
    AddSignature(data) {
        return axios.request({
            url: "api/esignature/addSignature",
            data: data,
            method: "post",
            headers: { "Content-Type": "multipart/form-data" },
        });
    },
    autoSignAuth(data) {
        return getPostRequest(data, "api/esignature/autoSignAuth");
    },
    // 获取余额提现单列表
    webGetRefundList(data) {
        return getPostRequest(
            data,
            "web/financeManagement/refund/getRefundList",
        );
    },
    // 撤回余额提现
    getCancelRefund(data) {
        return getPostRequest(data, "api/saleManagement/refund/cancelRefund");
    },
    // 申请余额提现
    getSaveRefund(data) {
        return getPostRequest(data, "api/saleManagement/refund/saveRefund");
    },
    // 公告
    getNoticeList(data) {
        return getPostRequest(
            data,
            "api/systemManagement/notice/getNoticeList",
        );
    },
    // 通知
    getOrderNotice(data) {
        return getPostRequest(data, "api/systemManagement/msg/getMsgList");
    },
    getPayPlatformConfigList(data) {
        return getPostRequest(
            data,
            "api/systemManagement/payPlatformManagement/getPayPlatformConfigList",
        );
    },
    // 物流信息
    getLogisticsList(data) {
        return getPostRequest(
            data,
            "api/saleManagement/shipping/getShippingList",
        );
    },
    getMemberDetailInfo(data) {
        return getPostRequest(
            data,
            "web/systemManagement/memberManagement/memberInfo/webGetMemberUserDetail",
        );
    },
    // 省市区
    webGetRegionCascade(data) {
        return getPostRequest(
            data,
            "web/systemManagement/regionManagement/webGetRegionCascade",
        );
    },
    // 发货单
    getPreSaleDeliveryRecordList(data) {
        return getPostRequest(
            data,
            "api/preSaleManagement/delivery/getAPPPreSaleDeliveryListByUuid",
        );
    },
    getPreSaleDeliveryRecordListByUuid(data) {
        return getPostRequest(
            data,
            "api/preSaleManagement/delivery/getPreSaleDeliveryListByUuid",
        );
    },
    getUserDepositBillInfoList(data) {
        return getPostRequest(
            data,
            "api/preSaleManagement/deposit/getAppDepositBillInfoList",
        );
    },
    webGetDepositBillOrderList(data) {
        return getPostRequest(
            data,
            "api/preSaleManagement/deposit/webGetDepositBillOrderList",
        );
    },
    updatePreSaleDeliveryByUuid(data) {
        return getPostRequest(
            data,
            "api/preSaleManagement/delivery/updatePreSaleDeliveryByUuid",
        );
    },
    // 广告图
    getAdList(data) {
        return getPostRequest(data, "api/systemManagement/ad/getAdList");
    },
};

const product = {
    getProductList(data) {
        return getPostRequest(data, "web/product/getProductList");
    },
    getPreSaleOrderProductPlanList(data) {
        return getPostRequest(
            data,
            "web/preSaleManagement/order/getPreSaleOrderListProdcutList",
        );
    },
    getProductInfo(data) {
        return getPostRequest(
            data,
            "web/productManagement/product/webGetProductDetail",
        );
    },
    getProductDescriptiveInformation(data) {
        return getPostRequest(
            data,
            "api/productManagement/product/getProductDescriptiveInformation",
        );
    },
    webGetMyFavProducts(data) {
        return getPostRequest(
            data,
            "web/productManagement/product/webGetMyFavProducts",
        );
    },
    webAddProductFav(data) {
        return getPostRequest(
            data,
            "web/productManagement/product/webAddProductFav",
        );
    },
    webDelProductFav(data) {
        return getPostRequest(
            data,
            "web/productManagement/product/webRemoveProductFav",
        );
    },
    getUnitList(data) {
        return getPostRequest(
            data,
            "api/systemManagement/unitManagement/getUnitList",
        );
    },
};

const category = {
    webGetMainCategoryList(data) {
        return getPostRequest(data, "web/category/getMainCategoryList");
    },
    webGetSubCategoryList(data) {
        return getPostRequest(data, "web/category/getSubCategoryList");
    },
    webGetBrandList(data) {
        return getPostRequest(data, "web/brand/webGetBrandList");
    },
    webGetSerialList(data) {
        return getPostRequest(data, "web/serial/webGetSerialList");
    },
};

const sales = {
    webCurSaleProductList(data) {
        return getPostRequest(
            data,
            "web/curSaleManagement/shopping/webCurSaleProductList",
        );
    },
    webCurrentSaleGetMyCart(data) {
        return getPostRequest(
            data,
            "web/curSaleManagement/shopping/webCurSaleGetMyCart",
        );
    },
    webCurrentSaleAddToCart(data) {
        return getPostRequest(
            data,
            "web/curSaleManagement/shopping/webCurSaleAddToCartController",
        );
    },
    webCurrentSaleUpdateCart(data) {
        return getPostRequest(
            data,
            "web/curSaleManagement/shopping/webCurSaleUpdateCart",
        );
    },
    webCurrentSaleRemoveFromCart(data) {
        return getPostRequest(
            data,
            "web/curSaleManagement/shopping/webCurSaleRemoveFromCart",
        );
    },
    webCurrentSaleSubmitOrder(data) {
        return getPostRequest(
            data,
            "web/curSaleManagement/order/webCurSaleSubmitOrder",
        );
    },
    webCurrentSaleGetMyOrder(data) {
        return getPostRequest(
            data,
            "web/curSaleManagement/order/webCurSaleGetMyOrder",
        );
    },
    webCurrentSaleCloseOrder(data) {
        return getPostRequest(
            data,
            "web/curSaleManagement/order/webCurSaleCloseOrder",
        );
    },
    webCurrentSaleGetOrderDetail(data) {
        return getPostRequest(
            data,
            "web/curSaleManagement/order/webCurSaleGetOrderDetail",
        );
    },
    webGetCurSaleOrderDeliveryList(data) {
        return getPostRequest(
            data,
            "web/distributionStationProductStore/delivery/webGetCurSaleOrderDeliveryList",
        );
    },
    webCurrentSalePayWithFund(data) {
        return getPostRequest(
            data,
            "web/curSaleManagement/order/webCurSaleDepositPayWithFund",
        );
    },
    webGetShoppingCartList(data) {
        return getPostRequest(
            data,
            "web/combine/shopping/webGetShoppingCartList",
        );
    },
    // 购物车列表
    getAppPreSaleOrderList(data) {
        return getPostRequest(
            data,
            "api/preSaleManagement/order/getAppPreSaleOrderList",
        );
    },
    // 购物车列表,不含提交的意向单产品
    getAppPreSaleOrderNoSumbitIntentioList(data) {
        return getPostRequest(
            data,
            "api/preSaleManagement/order/getAppPreSaleOrderNoSumbitIntentioList",
        );
    },
    // 购物车提交订单
    getSubmitDepositBillRecord(data) {
        return getPostRequest(
            data,
            "api/preSaleManagement/deposit/submitDepositBillRecord",
        );
    },
    // 购物车提交订单
    submitDepositBillRecord(data) {
        return getPostRequest(
            data,
            "api/preSaleManagement/deposit/submitDepositBillRecord",
        );
    },
    //通过预售详情单查询定金单
    getDepositBillListByPreSaleUuid(data) {
        return getPostRequest(
            data,
            "api/preSaleManagement/deposit/getDepositBillListByPreSaleUuid",
        );
    },
    // 根据预售单ID获取苗场列表
    getSeedFarmListByPreSaleOrderUuids(data) {
        return getPostRequest(
            data,
            "api/systemManagement/seedFarmManagement/getSeedFarmListByPreSaleOrderUuids",
        );
    },
    // 购物车提交意向单
    submitIntentionRecord(data) {
        return getPostRequest(
            data,
            "api/preSaleManagement/deposit/submitIntentionRecord",
        );
    },
    //支付订金、余额
    webPreSaleDepositPayWithFund(data) {
        return getPostRequest(
            data,
            "web/preSaleManagement/order/webPreSaleDepositPayWithFund",
        );
    },
    // 地址
    getUserAddressInfo(data) {
        return getPostRequest(data, "web/combine/shopping/updateOrderAddress");
    },
    // 投诉订单
    getComplainList(data) {
        return getPostRequest(
            data,
            "api/saleManagement/Complain/getComplainList",
        );
    },
    webSubmitToOrder(data) {
        return getPostRequest(data, "web/combine/shopping/webSubmitToOrder");
    },
    webGetOrderList(data) {
        return getPostRequest(data, "web/combine/shopping/webGetOrderList");
    },
    webChangeOrderStation(data) {
        return getPostRequest(
            data,
            "web/combine/shopping/webChangeOrderStation",
        );
    },
    webGetContract(data) {
        return getPostRequest(data, "web/combine/shopping/webGetContract");
    },
    webOrderDeliveryConfirmReceive(data) {
        return getPostRequest(
            data,
            "web/distributionStationProductStore/delivery/webOrderDeliveryConfirmReceive",
        );
    },
    webOrderDeliveryComplain(data) {
        return getPostRequest(
            data,
            "web/distributionStationProductStore/delivery/webOrderDeliveryComplain",
        );
    },
    addComplain(data) {
        return getPostRequest(data, "api/saleManagement/Complain/addComplain");
    },
    deleteComplain(data) {
        return getPostRequest(
            data,
            "api/saleManagement/Complain/deleteComplain",
        );
    },
    getComplainInfo(data) {
        return getPostRequest(
            data,
            "api/saleManagement/Complain/getComplainInfo",
        );
    },
    getSeedFarmCurSaleToDistributionStationBySeedFarm(data) {
        return getPostRequest(
            data,
            "api/systemManagement/seedFarmManagement/getSeedFarmCurSaleToDistributionStationBySeedFarm",
        );
    },
    closePreSaleOrder(data) {
        return getPostRequest(
            data,
            "api/preSaleManagement/order/closePreSaleOrder",
        );
    },
    closePreSaleOrderListBySendProductDate(data) {
        return getPostRequest(
            data,
            "api/preSaleManagement/order/closePreSaleOrderListBySendProductDate",
        );
    },
    updatePreSaleOrderByUuid(data) {
        return getPostRequest(
            data,
            "api/preSaleManagement/order/updatePreSaleOrderByUuid",
        );
    },
    webGetNoPaidDepositBillOrderList(data) {
        return getPostRequest(
            data,
            "api/preSaleManagement/deposit/webGetNoPaidDepositBillOrderList",
        );
    },
    webGetIntentionBillOrderList(data) {
        return getPostRequest(
            data,
            "api/preSaleManagement/deposit/getIntentionBillOrderList",
        );
    },
    closeDepositBillOrder(data) {
        return getPostRequest(
            data,
            "api/preSaleManagement/deposit/closeDepositBillOrder",
        );
    },
    closeIntentionBillOrder(data) {
        return getPostRequest(
            data,
            "api/preSaleManagement/deposit/closeIntentionBillOrder",
        );
    },
};

const booking = {
    webGetWeekConfig(data) {
        return getPostRequest(
            data,
            "web/preSaleManagement/preSalePlan/webGetWeekConfig",
        );
    },
    webGetPreSaleProductList(data) {
        return getPostRequest(
            data,
            "web/preSaleManagement/preSalePlan/webGetPreSaleProductList",
        );
    },
    webPreSaleAddToCart(data) {
        return getPostRequest(
            data,
            "web/preSaleManagement/preSalePlan/webPreSaleAddToCart",
        );
    },
    webPreSaleRemoveFromCart(data) {
        return getPostRequest(
            data,
            "web/preSaleManagement/preSalePlan/webPreSaleRemoveFromCart",
        );
    },
    webPreSaleGetMyCart(data) {
        return getPostRequest(
            data,
            "web/preSaleManagement/preSalePlan/webPreSaleGetMyCart",
        );
    },
    webPreSaleSubmitOrder(data) {
        return getPostRequest(
            data,
            "web/preSaleManagement/order/webPreSaleSubmitOrder",
        );
    },
    webPreSaleGetMyOrder(data) {
        return getPostRequest(
            data,
            "web/preSaleManagement/order/webPreSaleGetMyOrder",
        );
    },
    webPreSaleCloseOrder(data) {
        return getPostRequest(
            data,
            "web/preSaleManagement/order/webPreSaleCloseOrder",
        );
    },
    webPreSaleGetOrderDetail(data) {
        return getPostRequest(
            data,
            "api/preSaleManagement/deposit/getAppDepositBillInfo",
        );
    },
    webIntentionGetOrderDetail(data) {
        return getPostRequest(
            data,
            "api/preSaleManagement/deposit/webIntentionGetOrderDetail",
        );
    },
    webGetPreSaleOrderDeliveryList(data) {
        return getPostRequest(
            data,
            "web/distributionStationProductStore/delivery/webGetPreSaleOrderDeliveryList",
        );
    },
    webPreSaleDepositPayWithFund(data) {
        return getPostRequest(
            data,
            "web/preSaleManagement/order/webPreSaleDepositPayWithFund",
        );
    },
    webPreSaleUpdateCart(data) {
        return getPostRequest(
            data,
            "web/preSaleManagement/preSalePlan/webPreSaleUpdateCartController",
        );
    },
    webGetPreSaleOrderRelateForwardDelivery(data) {
        return getPostRequest(
            data,
            "web/preSaleManagement/forwardDelivery/webGetPreSaleOrderRelateForwardDelivery",
        );
    },
    webGetPreSaleForwardDeliveryDetail(data) {
        return getPostRequest(
            data,
            "web/preSaleManagement/forwardDelivery/webGetPreSaleForwardDeliveryDetail",
        );
    },
    webCustomerSetForwardDeliveryResponse(data) {
        return getPostRequest(
            data,
            "web/preSaleManagement/forwardDelivery/webCustomerSetForwardDeliveryResponse",
        );
    },
    modifyPreSaleOrderConfirm(data) {
        return getPostRequest(
            data,
            "api/preSaleManagement/order/modifyPreSaleOrderConfirm",
        );
    },
};

const pay = {
    createAliPay(data) {
        return getPostRequest(
            data,
            "web/paymentManagemenbt/AliPay/createAliPay",
        );
    },
    notifyAliPay(data) {
        return getPostRequest(
            data,
            "web/paymentManagemenbt/AliPay/notifyAliPay",
        );
    },
    queryAliPay(data) {
        return getPostRequest(
            data,
            "web/paymentManagemenbt/AliPay/queryAliPay",
        );
    },
    createWeiXinPay(data) {
        return getPostRequest(
            data,
            "web/paymentManagemenbt/WeiXin/createWeiXinPay",
        );
    },
    queryWeiXinPay(data) {
        return getPostRequest(
            data,
            "web/paymentManagemenbt/WeiXin/queryWeiXinPay",
        );
    },

    //abc支付
    QueryABCPay(data) {
        return getPostRequest(
            data,
            "web/paymentManagemenbt/ABCPay/QueryABCPay",
        );
    },
    createABCWeixin(data) {
        return getPostRequest(
            data,
            "web/paymentManagemenbt/ABCPay/createABCWeixin",
        );
    },
    createABCAliPay(data) {
        return getPostRequest(
            data,
            "web/paymentManagemenbt/ABCPay/createABCAliPay",
        );
    },
    createABCABCPay(data) {
        return getPostRequest(
            data,
            "web/paymentManagemenbt/ABCPay/createABCABCPay",
        );
    },
    createCMBPay(data) {
        return getPostRequest(
            data,
            "web/paymentManagemenbt/CMBPay/createCMBPay",
        );
    },
    createCCBCPay(data) {
        return getPostRequest(
            data,
            "web/paymentManagemenbt/CCBCPay/createCCBCPay",
        );
    },
    QueryCMBPay(data) {
        return getPostRequest(
            data,
            "web/paymentManagemenbt/CMBPay/QueryCMBPay",
        );
    },
    QueryCCBCPay(data) {
        return getPostRequest(
            data,
            "web/paymentManagemenbt/CCBCPay/QueryCCBCPay",
        );
    },
    getPaymentChannel(data) {
        return getPostRequest(
            data,
            "api/systemManagement/systemSetting/getPaymentChannel",
        );
    },
    getCMBMaxMoney(data) {
        return getPostRequest(
            data,
            "web/paymentManagemenbt/CMBPay/getCMBMaxMoney",
        );
    },
    // 获取飞收付款二维码
    createFeiShouPay(data) {
        return getPostRequest(data, "https://pay.kainonly.com/tlfs/apply");
    },
};

const home = {
    webGetAdvertisementList(data) {
        return getPostRequest(
            data,
            "api/advertisement/webGetAdvertisementList",
        );
    },
};

const pageInit = {
    // getSalesPageData(data) {
    //     return axiosOri.all([
    //         category.webGetMainCategoryList(data),
    //         category.webGetSubCategoryList(data),
    //         category.webGetBrandList(data),
    //         category.webGetSerialList(data)
    //     ]).then(axiosOri.spread(function (a, b, c, d) {
    //         if (a.code === 0 && b.code === 0 && c.code === 0 && d.code === 0) {
    //             return {
    //                 code: 0,
    //                 message: '',
    //                 data: {
    //                     mainCateList: a.data,
    //                     subCateList: b.data,
    //                     brandList: c.data,
    //                     serialList: d.data
    //                 }
    //             };
    //         }
    //     }));
    // },
    getSalesPageData(data) {
        return axiosOri
            .all([
                category.webGetMainCategoryList(data),
                category.webGetSubCategoryList(data),
            ])
            .then(
                axiosOri.spread(function (a, b) {
                    if (a.code === 0 && b.code === 0) {
                        return {
                            code: 0,
                            message: "",
                            data: {
                                mainCateList: a.data,
                                subCateList: b.data,
                            },
                        };
                    }
                }),
            );
    },
    getMemberRegisterData(data) {
        return axiosOri
            .all([
                user.webGetAllRegion(data),
                user.webGetCateManagerRelationList(data),
                user.webGetAreaList(data),
            ])
            .then(
                axiosOri.spread(function (a, b, c) {
                    if (a.code === 0 && b.code === 0 && c.code === 0) {
                        return {
                            code: 0,
                            message: "",
                            data: {
                                allRegions: a.data,
                                cateManagerRelation: b.data,
                                areaList: c.data,
                            },
                        };
                    }
                }),
            );
    },
};

const uploadFileConfig = {
    uploadFile2Qiniu: axios.getBaseUrl() + "/api/files/uploadFiles2Qiniu",
    uploadFileAction: axios.getBaseUrl() + "/api/files/uploadFiles",
    fileServer: axios.getFileServerUrl() + "/",
    baseFileServer: axios.getFileServerUrl() + "/",
    downLoadServer: config.downLoadFileUrl[config.appEnv] + "/",
};

const combine = Object.assign(
    {},
    home,
    user,
    product,
    sales,
    booking,
    category,
    pageInit,
    uploadFileConfig,
    pay,
);

export default combine;



// WEBPACK FOOTER //
// ./src/api/api.js